import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const PremiumAmexFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.50002 5.83325H3.03032C2.27721 5.83325 1.66669 6.43953 1.66669 7.18742V15.3124C1.66669 16.0603 2.27721 16.6666 3.03032 16.6666H15.3031C16.0562 16.6666 16.6667 16.0603 16.6667 15.3124V13.7499"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.62158 10.0801L3.85742 13H3.10303L4.21387 9.44531H4.68506L4.62158 10.0801ZM5.22461 13L4.45557 10.0801L4.38477 9.44531H4.86328L5.98389 13H5.22461ZM5.25146 11.6743V12.2676H3.64746V11.6743H5.25146Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
      <path
        d="M6.57715 9.44531H7.20459L7.92969 11.877L8.65234 9.44531H9.20654L8.1958 13H7.66113L6.57715 9.44531ZM6.32324 9.44531H6.92139L7.01416 11.7891V13H6.32324V9.44531ZM8.93311 9.44531H9.53369V13H8.84521V11.7891L8.93311 9.44531Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
      <path
        d="M12.1558 12.4092V13H10.6104V12.4092H12.1558ZM10.8325 9.44531V13H10.1172V9.44531H10.8325ZM11.0469 10.8857V11.4595H10.6104V10.8857H11.0469ZM11.2299 9.44531L11.1148 10.0386H10.6104V9.44531H11.2299Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
      <path
        d="M13.098 11.518L14.2607 10.8857L14.126 11.2056L15 13H14.1797L13.6743 11.7866L13.1689 13H12.3657L13.098 11.518Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
      <path
        d="M14.6528 3.33325L15.833 5.72422L18.4722 6.10999L16.5625 7.97006L17.0132 10.5978L14.6528 9.35652L12.2923 10.5978L12.743 7.97006L10.8333 6.10999L13.4725 5.72422L14.6528 3.33325Z"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PremiumAmexFilterIcon;
